import type { AthleteProfile } from "./types/athleteProfile";

export type AthleteProfileState = {
  profile: AthleteProfile;
  hasUnsavedChanges: boolean;
};

export type AthleteProfileAction =
  | { type: "edit"; profile: AthleteProfile }
  | { type: "saved"; profile: AthleteProfile }
  | { type: "reset"; profile: AthleteProfile };

export function reduceAthleteProfileState(state: AthleteProfileState, action: AthleteProfileAction): AthleteProfileState {
  if (action.type === "edit") {
    return { profile: action.profile, hasUnsavedChanges: true };
  }

  return { profile: action.profile, hasUnsavedChanges: false };
}
